<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-3">
        <SearchBox
          v-model="fetchOptions"
          :waiting="fetchIngProduct"
          @onEnter="fetchProduct"
          :placeholder="$t('sparePartReplacement.serialNumber')"
        />

        <table class="ts-w-full ts-mt-3">
          <thead>
            <tr>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase ts-w-48">
                {{ $t('returnToVendor.stockInNumber') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase">
                {{ $t('returnToVendor.productGroup') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase">
                {{ $t('returnToVendor.productName') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase">
                {{ $t('returnToVendor.productType') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase">
                {{ $t('returnToVendor.uom') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase">
                {{ $t('returnToVendor.cost') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase ts-w-32">
                {{ $t('returnToVendor.quantity') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase ts-w-48">
                {{ $t('returnToVendor.status') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-uppercase ts-w-1/4">
                {{ $t('returnToVendor.remark') }}
              </th>
              <th class="ts-bg-gray-300 ts-p-2 ts-w-4 ts-uppercase">
                <a href="#" @click.prevent="manualAdd"
                  ><i class="fa fa-plus"></i
                ></a>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(detail, mIndex) in model.product_detail">
              <tr :key="mIndex" class="ts-bg-blue-100">
                <td class="ts-p-2" valign="middle">
                  <p
                    class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold"
                  >
                    {{ detail.stock_in_number }}
                  </p>
                </td>
                <td class="ts-p-2" valign="middle">
                  <p
                    class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold"
                  >
                    {{ detail.pro_group_name_en }}
                  </p>
                </td>
                <td class="ts-p-2" valign="middle">
                  <p
                    class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold"
                  >
                    {{ detail.product_name_en }}
                  </p>
                </td>
                <td class="ts-p-2" valign="middle">
                  <p
                    class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold"
                  >
                    {{ detail.product_type_en }}
                  </p>
                </td>
                <td class="ts-p-2" valign="middle">
                  <p
                    class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold"
                  >
                    {{ detail.uom_name_en }}
                  </p>
                </td>
                <td class="ts-p-2" valign="middle">
                  <p
                    class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold"
                  >
                    {{ detail.cost }}
                  </p>
                </td>
                <td class="ts-p-2" valign="middle">
                  <input
                    v-model="detail.quantity"
                    type="number"
                    class="ts-w-full ts-outline-none ts-font-bold ts-p-2 ts-text-blue-500 ts-border ts-border-gray-400 ts-rounded"
                  />
                  <div class="validate" v-if="errors.has('product_detail.'+ mIndex + '.quantity')">
                    {{ errors.first('product_detail.'+ mIndex + '.quantity') }}
                  </div>
                </td>
                <td class="ts-p-2" valign="middle">
                  <select
                    v-model="detail.return_status_id"
                    class="ts-w-full ts-font-bold ts-outline-none ts-p-2 ts-text-blue-500 ts-border ts-border-gray-400 ts-rounded"
                  >
                    <option
                      v-for="(st, index) in status"
                      :key="index"
                      :value="st.return_status_id"
                      >{{ st.return_status }}</option
                    >
                  </select>
                </td>
                <td class="ts-p-2">
                  <input
                    v-model.trim="detail.remarks"
                    type="text"
                    class="ts-w-full ts-outline-none ts-p-2 ts-text-blue-500 ts-border ts-border-gray-400 ts-rounded"
                    placeholder="leave your remark here..."
                  />
                </td>
                <td class="ts-p-2 ts-text-center">
                  <a
                    href="#"
                    class="ts-text-red-600"
                    @click.prevent="deleteMainProduct(mIndex)"
                    ><i class="fa fa-trash"></i
                  ></a>
                </td>             
							</tr>
							<tr v-if="errors.has('product_detail.'+ mIndex + '.serials')">
								<td colspan="10">
									<b><p class="validate">{{ errors.first('product_detail.'+ mIndex + '.serials') }}</p></b>
								</td> 
							</tr>
              <tr v-if="detail.serials.length > 0">
                <td></td>
                <td colspan="8" class="ts-p-2">
                  <div
                    class="max-h ts-border ts-border-blue-300 ts-rounded ts-p-2 ts-space-y-2 ts-space-x-1 ts-overflow-scroll"
                  >
                    <div
                      class="ts-bg-blue-200 ts-p-2 ts-rounded ts-font-bold w-fit ts-inline-block"
                      v-for="(serial, index) in detail.serials"
                      :key="serial"
                    >
                      {{ serial }}
                      <span
                        @click.prevent="deleteSerial(mIndex, index)"
                        class="ts-text-red-600 ts-bg-gray-200 ts-px-2 ts-rounded-full ts-cursor-pointer"
                       
                        >X</span
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <a-modal
          v-if="show_manual_add"
          v-model="show_manual_add"
          :title="$t('returnToVendor.addProduct')"
          :footer="null"
          :centered="true"
          :zIndex="1020"
          :maskClosable="false"
          width="40%"
        >
          <Manual v-model="model" @close="() => (show_manual_add = false)" />
        </a-modal>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SearchBox from './search-box.vue'
import Manual from './manual-add.vue'
import { Errors } from 'form-backend-validation'
export default {
  name: 'detailComponent',
  props: ['value', 'validate'],
  components: {
    SearchBox,
    Manual
  },
  data() {
    return {
			errors: new Errors(),
      fetchIngProduct: false,
      fetchOptions: {
        search_value: ''
      },
      loading: false,
      show_manual_add: false,
      model: {},
      row: {
        product_id: null,
        product_name_en: null,
        uom_id: null,
        uom_name_en: null,
        quantity: 0,
        cost: 0,
        return_status_id: 1,
        stock_in_id: null,
        stock_in_number: null,
        remarks: null,
        has_serial: false,
        pro_group_name_en: null,
        product_type_en: null,
        serials: []
      }
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('stock/returnToVendor', ['status'])
  },
  methods: {
    ...mapActions('stock/returnToVendor', ['findBySerial']),
    fetchProduct() {
      if (!this.fetchOptions.search_value) {
        return
      }
      this.loading = true
      this.findBySerial(this.fetchOptions.search_value)
        .then(response => {
          this.pushNewOrUpdateQuantity(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetchOptions.search_value = ''
          this.loading = false
        })
    },
    deleteMainProduct(index) {
      this.model.product_detail.splice(index, 1)
    },
    deleteSerial(mainIndex, serialIndex) {
      this.model.product_detail[mainIndex].serials.splice(serialIndex, 1)
      this.model.product_detail[mainIndex].quantity = this.model.product_detail[
        mainIndex
      ].serials.length
    },
    pushNewOrUpdateQuantity(foundProduct) {
      let existing = this.model.product_detail.filter(
        p =>
          p.stock_in_id == foundProduct.stock_in_id &&
          p.product_id == foundProduct.product_id
      )
      if (existing.length > 0) {
        existing.forEach(el => {
          if (!_.includes(el.serials, foundProduct.serial_no)) {
            el.quantity = el.serials.length + 1
            el.serials.push(foundProduct.serial_no)
          }
        })
      } else {
        this.model.product_detail.push({
          product_id: foundProduct.product_id,
          product_name_en: foundProduct.product_name_en,
          uom_id: foundProduct.uom_id,
          uom_name_en: foundProduct.uom_name_en,
          quantity: 1,
		  has_serial: foundProduct.has_serial,
          cost: foundProduct.cost,
          return_status_id: 1,
          stock_in_id: foundProduct.stock_in_id,
          stock_in_number: foundProduct.stock_in_number,
          pro_group_name_en: foundProduct.pro_group_name_en,
          product_type_en: foundProduct.product_type_en,
          remarks: '',
          serials: [foundProduct.serial_no]
        })
      }
    },
    manualAdd() {
      this.show_manual_add = true
    }
  },
	watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>

<style scoped>
.w-fit {
  width: fit-content;
}
.max-h {
  max-height: 300px;
  overflow: scroll;
}
</style>
